Ext.ns('mx.data');

mx.data.SimpleRecord = mx.data.Record.create([
    {
        name: 'id',
        type: 'string',
    },
    {
        name: 'name',
        type: 'string',
    },
    {
        name: 'value',
        type: 'string',
    },
]);
